import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'http://localhost:8080'
} else {
  axios.defaults.baseURL = ''
}

axios.defaults.withCredentials = true

axios.interceptors.response.use((response) => {
  console.log(response)

  // 如果返回的code为2说明没有登录且不在登录页，跳转到登录页面
  if (response.data.code === 2) {
    if (window.location.pathname.indexOf('login') >= 0) {
      // 在登陆页面，不跳转
    } else {
      if (window.location.pathname.indexOf('liquor') >= 0) {
        window.location.href = '/liquor/login'
      } else {
        window.location.href = '/login'
      }
    }
  }
  return response
}, (error) => {
  // 如果返回的error含有403说明没有登录且不在登录页，跳转到登录页面
  if (error.toString().indexOf('403') >= 0) {
    if (window.location.pathname.indexOf('login') >= 0) {
      // 在登陆页面，不跳转
    } else {
      if (window.location.pathname.indexOf('liquor') >= 0) {
        window.location.href = '/liquor/login'
      } else {
        window.location.href = '/login'
      }
    }
  }
  return Promise.reject(error)
})

const ajax = async(url, params, method = 'POST') => {
  const data = new FormData()
  if (params) {
    Object.keys(params).forEach(k => {
      if (params[k]) {
        data.append(k, params[k])
      }
    })
  }
  const response = await axios({
    url,
    method,
    data
  })
  return response.data
}

const kv = (k, v) => {
  let result = {
    k
  }

  if (v) {
    result.v = v
  } else {
    result.v = null
  }
  return result
}

const doPost = async({ commit, state }, { packageName, className, methodName, params, method }) => {
  const response = await ajax(`/api/${packageName}/${className}/${methodName}`, params, method)

  const payload = {
    packageName,
    className,
    methodName,
    data: response.data
  }

  commit('PUT', payload)
}

const doLogin = async({ commit, state }, { params }) => {
  const response = await ajax('/api/login', params)

  const payload = {
    packageName: 'sys',
    className: 'sysUser',
    methodName: 'get',
    data: response.data
  }

  commit('PUT', payload)
}

const doLogout = async({ commit }) => {
  await ajax('/api/logout')

  const payload = {
    packageName: 'sys',
    className: 'sysUser',
    methodName: 'get',
    data: null
  }

  commit('PUT', payload)
}

const doCheck = async({ commit }) => {
  const response = await ajax('/api/sys/sysUser/check')

  const payload = {
    packageName: 'sys',
    className: 'sysUser',
    methodName: 'check',
    data: response.data
  }

  commit('PUT', payload)
}

Vue.use(Vuex)

function getParentCode(code) {
  const result = code.slice(0, code.length - 2)
  return result
}

const retrieve = {
  page: {
    pageNum: 1,
    pageCount: 0,
    numPerPage: 10
  },
  results: []
}

export default new Vuex.Store({
  state: {
    game: {
      currentScene: 'MainScene',
      currentCheckpointId: 1,
      copyId: 0,
      currentCheckpointResult: 'B',
      audioSwitch: false,
      taskStatus: 'unfinished',
      foregroundMusicSrc: '',
      backgroundMusicSrc: '',
      common: {
        getMyBackpack: [
          {
            name: '赤霞珠',
            count: 0
          },
          {
            name: '梅洛',
            count: 0
          },
          {
            name: '西拉',
            count: 0
          },
          {
            name: '黑皮诺',
            count: 0
          },
          {
            name: '霞多丽',
            count: 0
          },
          {
            name: '长相思',
            count: 0
          },
          {
            name: '雷司令',
            count: 0
          }
        ]
      },
      gameCheckpoint: {
        get: {
          id: 0,
          name: '',
          plot: '',
          taskName: '',
          rewardResIds: '',
          orderNum: ''
        },
        retrieve
      },
      gameQuestion: {
        get: {
          checkpointId: 0,
          orderNum: 0,
          description: '',
          difficulty: '',
          optionA: '',
          optionB: '',
          optionC: '',
          optionD: '',
          answer: ''
        },
        retrieve
      },
      gameResource: {
        retrieve
      },
      gameReward: {
        retrieve
      },
      gameTask: {
        retrieve
      },
      gameTaskResource: {
        retrieve
      },
      gameUserAnswer: {
        retrieve
      }
    },
    product: {
      productBase: {
        get: {},
        retrieve,
        popularityRanking: [],
        latestUploading: [],
        search: retrieve
      },
      productSalesData: {
        retrieve
      },
      productSalesInfo: {
        retrieve
      },
      productSupplier: {
        retrieve
      },
      productCategory: {
        retrieve,
        getCategoryByCode: []
      },
      freshOriginInfo: {   // 生鲜供应链产区地下拉框选项
        getSelectOptions: {},
        retrieve,
        count: []
      },
      firm: {
        firmCategory: []
      },
      productFoodWiki: {
        get: {}
      }
    },
    marketing: {
      commodityMarketing: {
        retrieve,
        get: {
          id: ''
        }
      },
      commodityMarketingImage: {
        retrieve
      },
      commodityMarketingPlanningMaterial: {
        retrieve
      }
    },
    sc: {
      scSaleCommodity: {
        retrieve: '',
        latest: '',
        getSyncTime: ''
      },
      scSaleProvince: {
        retrieve: '',
        latest: '',
        getSyncTime: '',
        ranking: ''
      },
      scSaleShop: {
        retrieve: '',
        latest: '',
        getSyncTime: '',
        ranking: ''
      },
      scSupplierAll: {
        retrieve: '',
        latest: '',
        getSyncTime: ''
      },
      scSupplierProvince: {
        retrieve: '',
        latest: ''
      }
    },
    ovop: {
      oneVillageOneProduct: {
        retrieve,
        get: {
          id: ''
        },
        explore: {
          onlineCount: 0,
          provinceCount: 0,
          cityCount: 0,
          importCount: 0
        },
        provinceExplore: {
          onlineCount: 0,
          cityCount: 0,
          importCount: 0
        }
      }
    },
    user: {
      userComment: {
        create: {},
        get: {},
        retrieve,
        getCommentsByTarget: {
          userInfos: [],
          userLikes: [],
          userComments: []
        },
        getCommentsByTargetWithMe: retrieve
      },
      userLike: {
        create: {}
      },
      userHistory: {
        create: {}
      },
      userFavorite: {
        retrieve,
        create: {},
        delete: {}
      }
    },
    common: {
      resource: {
        movePic: ''
      }
    },
    sys: {
      sysUser: {
        my: {
          activeValue: {
            value: 0,
            list: []
          },
          onlineTime: 0,
          collect: 0,
          footprint: 0
        },
        me: {
          authorities: []
        },
        check: {},
        get: {
          id: ''
        }
      },
      sysUserExt: {
        get: {
          onlineTime: 0
        }
      }
    }
  },
  getters: {
    getAuthorities: state => state.sys.sysUser.me.authorities,
    getProductCategoryOptions: (state) => () => state.product.productCategory.retrieve.results
      .sort((a, b) => parseInt(a.code) - parseInt(b.code))
      .filter(e => e.level == 2)
      .map(e => {
        e.status = 0
        e.children = state.product.productCategory.retrieve.results.filter(ee => ee.level == 3 && e.code == getParentCode(ee.code)).map(ee => {
          ee.children = state.product.productCategory.retrieve.results.filter(eee => eee.level == 4 && ee.code == getParentCode(eee.code))
          return ee
        })
        return e
      }),
    getCategoryOptions: (state) => () => state.product.productCategory.retrieve.results,
    getCommodityMarketing: (state) => () => {
      let bean = state.marketing.commodityMarketing.get
      if (bean) {
        bean.planningMaterials = state.marketing.commodityMarketingPlanningMaterial.retrieve.results
        bean.images = state.marketing.commodityMarketingImage.retrieve.results
      }

      console.log(bean)
      return bean
    }
  },
  mutations: {
    SET(state, payload) {
      state[payload.k] = payload.v
    },
    PUT(state, payload) {
      state[payload.packageName][payload.className][payload.methodName] = payload.data
    },
    setCurrentCheckpointId(state, payload) {
      state.game.currentCheckpointId = payload
      state.game.gameCheckpoint.get = state.game.gameCheckpoint.retrieve.results.find(e => e.id == payload)
    },
    setCopyId(state, payload) {
      state.game.copyId = payload
    },
    setTaskStatus(state, payload) {
      state.game.taskStatus = payload

      console.log(state.game)
    },
    setAudioSwitch(state, payload) {
      state.game.audioSwitch = payload
    },
    setCurrentCheckpointResult(state, payload) {
      state.game.currentCheckpointResult = payload
    },
    setForegroundMusicSrc(state, payload) {
      state.game.foregroundMusicSrc = payload
    },
    setBackgroundMusicSrc(state, payload) {
      state.game.backgroundMusicSrc = payload
    }
  },
  actions: {
    productCategoryPage: doPost,
    productBasePage: doPost,
    productBaseUpdateViewCount: doPost,
    productBasePopularityRanking: doPost,
    productBaseLatestUploading: doPost,
    productSalesDataPage: doPost,
    productSalesInfoPage: doPost,
    productSupplierPage: doPost,
    productCategoryList: doPost,

    userCommentPage: doPost,

    commodityMarketingPage: doPost,
    commodityMarketing: doPost,
    commodityMarketingImagePage: doPost,
    commodityMarketingPlanningMaterialPage: doPost,

    createComment: doPost,
    createLike: doPost,
    createHistory: doPost,

    scSaleCommodityData: doPost,
    scSaleProvinceData: doPost,
    scSaleShopData: doPost,
    scSupplierAllData: doPost,
    scSupplierProvinceData: doPost,
    scSupplierTimeData: doPost,
    oneVillageOneProductPage: doPost,
    oneVillageOneProduct: doPost,

    movePic: doPost,

    post: doPost,

    me: doPost,

    my: doPost,

    login: doLogin,
    logout: doLogout,
    check: doCheck
  }
})
